import React, { FC, createContext, useMemo, useState } from "react";
import useLanguageStore from "../store/LanguageStore";
import { US_English_Locale } from "common/constants/GlobalValues";

interface ILanguageContext {
  selectedLanguageLocale: string;
  updateSelectedLanguageLocale(apiBaseUrl: string, languageLocale: string): Promise<string>;
  getString(key: string): string;
}

export const LanguageContext = createContext<ILanguageContext>({
  selectedLanguageLocale: "",
  updateSelectedLanguageLocale: async () => "",
  getString: (key) => key,
});

interface IProps {
  children: React.ReactNode;
}
export const LanguageProvider: FC<IProps> = ({ children }) => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>("");
  const { fetchLanguages, languages } = useLanguageStore();

  const updateSelectedLanguageLocale = async (apiBaseUrl: string, languageLocale: string) => {
    console.log(`selectedLocal: ${selectedLanguage} request to fetch strings for ${languageLocale}`)
    const response = await fetchLanguages(apiBaseUrl, languageLocale.toLowerCase());
    if (response.succeeded === false) {
      console.log(`Errors fetching strings for ${languageLocale}, now fetching ${US_English_Locale}`)
      languageLocale = US_English_Locale;
      await fetchLanguages(apiBaseUrl, languageLocale);
    }
    setSelectedLanguage(languageLocale);
    return languageLocale;
  };
  
  const getString = (key: string) => {
    if (languages.has(selectedLanguage)) {
      const value = languages.get(selectedLanguage)?.get(key);
      return value !== undefined ? value : key;
    }
    return key;
  };

  const ctxValue: ILanguageContext = useMemo(() => {
    return {
      selectedLanguageLocale: selectedLanguage,
      updateSelectedLanguageLocale: updateSelectedLanguageLocale,
      getString: getString,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguage]); // We don't care if React thinks the two methods have changed

  return <LanguageContext.Provider value={ctxValue}>{children}</LanguageContext.Provider>;
};
